import { render, staticRenderFns } from "./PortalInvite.vue?vue&type=template&id=761fae52&scoped=true&"
import script from "./PortalInvite.vue?vue&type=script&lang=js&"
export * from "./PortalInvite.vue?vue&type=script&lang=js&"
import style0 from "./PortalInvite.vue?vue&type=style&index=0&id=761fae52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761fae52",
  null
  
)

export default component.exports